import { useAuth } from './context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

export default function SuperAdminRoute({ children }) {
  const { user, loading, isSuperAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="p-6">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/patients" replace />;
  }

  return children;
}
